export const googleReviews = [
  {
    name: 'Elif Aydin',
    text: 'Yalova Termal gezimizde kahvalti icin ugradik. Tabaklar taze, servis sakindi; kahvenin tadi da gercekten iyiydi.',
  },
  {
    name: 'Murat Demir',
    text: 'Kucuk ve temiz bir cafe. Sicak icecekler hizli geldi, tatli secenekleri de kahveyle guzel eslesiyor.',
  },
  {
    name: 'Selin Kaya',
    text: 'Serpme kahvalti bol ve dengeliydi. Kalabalik olmayan, rahat oturulabilen butik bir yer arayanlara uygun.',
  },
  {
    name: 'Caner Ozkan',
    text: 'Termal bolgesinde kisa mola icin guzel bir durak. Personel ilgili, ortam sade ve fiyatlar menu uzerinden net goruluyor.',
  },
]
